import { FC, ReactElement } from "react";

const Scissor:FC =():ReactElement=>{
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path d="M8.38 5.59c0-2.038-1.652-3.69-3.69-3.69s-3.69 1.652-3.69 3.69c0 2.038 1.652 3.69 3.69 3.69 0.96 0 1.826-0.376 2.483-0.976l1.827 1.687 0.012 0.009-0.004 0.003-1.836 1.693c-0.656-0.6-1.522-0.976-2.482-0.976-2.038 0-3.69 1.652-3.69 3.69s1.652 3.69 3.69 3.69 3.69-1.652 3.69-3.69c0-0.297-0.044-0.582-0.111-0.858l2.844-1.991 4.127 3.065c2.212 1.549 3.76-0.663 3.76-0.663l-10.731-7.515c0.066-0.276 0.111-0.561 0.111-0.858zM4.69 7.39c-0.994 0-1.8-0.806-1.8-1.8s0.806-1.8 1.8-1.8 1.8 0.806 1.8 1.8-0.806 1.8-1.8 1.8zM4.69 16.21c-0.994 0-1.8-0.806-1.8-1.8s0.806-1.8 1.8-1.8 1.8 0.806 1.8 1.8-0.806 1.8-1.8 1.8zM19 6.038c0 0-1.548-2.212-3.76-0.663l-3.205 2.235 2.354 1.648 4.611-3.22z"></path>
        </svg>
        
    )
}

export default Scissor;